import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ChatMessageFormView from '../component/ChatMessageFormView'
import {
  CHAT_MAX_TEXT_LENGTH,
  CHAT_MESSAGE_TYPES,
} from '../../../../shared/constants'
import { apiClient } from '../../../../Module/API/Client'

const ChatMessageForm = ({ onMessageSend }) => {
  const [messageValue, setMessageValue] = useState('')

  const onMessageChange = event => {
    const { value } = event.target
    if (value.length > CHAT_MAX_TEXT_LENGTH) {
      alert(
        `The text you've tried to input is too long, max length of the message: ${CHAT_MAX_TEXT_LENGTH} character(s)`,
      )
      return
    }
    return setMessageValue(value)
  }

  const onTextMessageSend = () => {
    if (messageValue.length > 0) {
      const messagePayload = {
        type: CHAT_MESSAGE_TYPES.TEXT,
        text: messageValue,
      }
      onMessageSend({ messagePayload })
      return setMessageValue('')
    }
  }

  const onFileUpload = async ({ type, file, onSuccess, onError }) => {
    const fileURL = await apiClient.uploadChatFile({
      file,
    })

    const messagePayload = {
      type,
      fileURL,
    }

    onMessageSend({ messagePayload })
  }

  return (
    <ChatMessageFormView
      messageValue={messageValue}
      onChange={onMessageChange}
      onSend={onTextMessageSend}
      onFileUpload={onFileUpload}
    />
  )
}

ChatMessageForm.propTypes = {
  onMessageSend: PropTypes.func,
}

export default ChatMessageForm
